// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageMouseCoordinates_wrapper__KF2Pe"};